











import { Component, Vue } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  isiOS = false

  mounted () {
    let userA = navigator.userAgent
    this.isiOS = !!userA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios移动终端
    if (this.isiOS) {
      let element: any = document.getElementsByClassName('download')[1]
      if (element) {
        element.innerText = '申请投递：open@wps.cn'
        element = document.getElementsByClassName('download')[2]
        element.innerText = '申请投递：open@wps.cn'
      }
    }
    const bodyEle: any = document.getElementsByTagName('body')[0]
    bodyEle.style.height = 'auto'
  }

  get docPath () {
    return this.isiOS ? 'javascript:void(0);' : '/doc/WPS_OPENPLATFORM_ACCESS_APPLY.docx'
  }

  toHome () {
    this.$router.push({ name: 'home' })
  }

  get isHome () {
    return this.$route.name === 'home' || this.$route.name === 'case-detail'
  }

  get isDoc () {
    return this.$route.path.indexOf('/docs') > -1
  }
}
